import { appInject, appInjectable } from "@core/di/utils";
import { BaseService } from "@core/services/base";
import { DI_TOKENS } from "@shared/constants/di";
import { IConfigService } from "@shared/interfaces/config-service.interface";
import { IHttpClientService } from "@shared/interfaces/http-client-service.interface";
import { IAchievementsService } from "@shared/interfaces/achievements-service.interface";
import {
  AchievementsListPaginatedDto,
  AssignAchievementDto,
  AssignAchievementResponseDto,
  GetAchievementsListDto,
} from "@shared/types/achievements/achievements.dto";

@appInjectable()
export class AchievementsService
  extends BaseService
  implements IAchievementsService
{
  private configService = appInject<IConfigService>(DI_TOKENS.configService);
  private httpClient = appInject<IHttpClientService>(
    DI_TOKENS.httpClientService,
  );
  private baseURL: string;

  constructor() {
    super();
    this.baseURL = this.configService.baseUrl;
  }

  getAchievementsList: IAchievementsService["getAchievementsList"] = async (
    params: GetAchievementsListDto,
  ) => {
    const { data } = await this.httpClient.get<{
      data: AchievementsListPaginatedDto;
    }>("/achievements/list", {
      params,
      baseURL: this.baseURL,
    });

    return data.data ?? (data as unknown as AchievementsListPaginatedDto);
  };

  assignAchievement: IAchievementsService["assignAchievement"] = async (
    body: AssignAchievementDto,
  ) => {
    const { data } = await this.httpClient.post<AssignAchievementResponseDto>(
      "/user-achievements",
      body,
      { baseURL: this.baseURL },
    );

    return data;
  };
}
